import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import { Formik } from "formik"
import { useMemo } from "react"
import { Container } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import BottomFormFixed from "../../components/BottomFormFixed"
import Layout from "../../components/Layout"
import { ScrollLayout } from "../../components/ScrollLayout"
import { useCreateTheme } from "../../hooks/themes"
import { type Theme } from "../../types"
import { initialValuesTheme, validationSchemaTheme } from "./ThemeCommon"
import ThemeForm from "./ThemeForm"

export default function ThemeCreate() {
  const createTheme = useCreateTheme()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesTheme(), [])
  const validationSchema = useMemo(() => validationSchemaTheme(), [])
  useBreadcrumbs([{ label: "Temi", href: "/themes/themes" }, { label: "Creazione Tema" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo tema</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createTheme.mutateAsync(values as Theme).then((theme) => {
                navigate(`/themes/themes/${theme.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <ThemeForm />
                </Container>
                <BottomFormFixed url="/themes/themes" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
